import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBrain, faCartShopping, faChartArea, faChartLine, faCircleQuestion, faCloudBolt, faCloudMoon, faCloudUpload, faGifts, faHistory, faImages, faList, faMedal, faPersonArrowUpFromLine, faPersonCircleQuestion, faPersonDotsFromLine, faPizzaSlice, faQuestion, faQuestionCircle, faSheetPlastic, faSquarePersonConfined, faTools, faTree, faVideo, faVideoCamera, faVideoSlash } from '@fortawesome/free-solid-svg-icons';
import './SevenWonders.css';
import sevenwondersimage from '../../assets/pageimages/SevenWonders.webp';
import { faArtstation } from '@fortawesome/free-brands-svg-icons';

function SevenWondersHome() {

  const LinkButton = ({ to, icon, label }) => (
      <div className="flex justify-center">
        <Link
          to={to}
          className="flex items-center flex-wrap justify-center p-3 w-full bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-all duration-300"
        >
          <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
          <span>{label}</span>
        </Link>
      </div>
    );
  
    const LinkNoButton = ({ to, icon, label }) => (
      <div className="flex justify-center">
        <Link
          to={""}
          className="flex items-center flex-wrap justify-center p-3 w-full bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition-all duration-300"
        >
          <FontAwesomeIcon icon={icon} className="text-xl sm:text-xl mr-3" />
          <span>{label}</span>
        </Link>
      </div>
    );

  return (
    <MainLayout>
      <div className="mt-12 text-sm min-h-screen bg-gradient-to-r from-pink-300 via-red-500 to-purple-600 flex flex-col items-center py-8">
        <h2 className="text-2xl font-bold text-white text-center mb-4">Seven Wonders - 7 Pieces Tanagram</h2>
          <img
            src={sevenwondersimage}
            alt="ThinkHealth"
            className="w-1/5 h-auto max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl rounded-lg shadow-lg flex-wrap"
          />
        <div>
          <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-5 gap-4 p-4 bg-gray-600 rounded-lg shadow-lg transition-transform transform mx-4 mt-6">
            <LinkNoButton to="/sevenwonders-books" icon={faList} label="Books" />
            <LinkNoButton to="/sevenwonders-brainbooster" icon={faBrain} label="Use as Brain Booster" />
            <LinkNoButton to="/sevenwonders-generaldeco" icon={faArtstation} label="General Decoration" />
            <LinkNoButton to="/sevenwonders-fooddeco" icon={faPizzaSlice} label="Food Decoration" />
            <LinkNoButton to="/orderflow-home" icon={faCartShopping} label="Physical Kit" style={{ backgroundColor: 'green', color: 'white' }} />
            <LinkNoButton to="/sevenwonders-badge" icon={faMedal} label="7Wonders Badge" style={{ backgroundColor: 'green', color: 'white' }} />
            <LinkNoButton to="/sevenwonders-prizes" icon={faGifts} label="7Wonders Prizes" style={{ backgroundColor: 'green', color: 'white' }} />
            <LinkNoButton to="/sevenwonders-imagecloud" icon={faCloudUpload} label="Image Cloud" style={{ backgroundColor: 'purple', color: 'white' }} />
            <LinkNoButton to="/sevenwonders-videocloud" icon={faCloudBolt} label="Video Cloud" style={{ backgroundColor: 'purple', color: 'white' }} />
            <LinkNoButton to="/sevenwonders-videochannel" icon={faVideoCamera} label="Video Channel" style={{ backgroundColor: 'blue', color: 'white' }} />
            <LinkNoButton to="/sevenwonders-about" icon={faQuestion} label="About 7Wonders" style={{ backgroundColor: 'blue', color: 'white' }} />
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default SevenWondersHome;
